import * as z from "zod/v4";
import { investmentListingStatusSchema } from "@fergmar/contracts/public/investment-listings";

export const salesListingFiltersSchema = z.object({
	minPrice: z.number().nullable(),
	maxPrice: z.number().nullable(),
	status: z.string().nullable(),
	type: z.string().nullable(),
	beds: z.number().nullable(),
	baths: z.number().nullable()
});

export type SalesListingFilters = z.infer<typeof salesListingFiltersSchema>;

export const sellPropertyTypes = ["Residential", "Multi-Family", "Commercial", "Land"];

export const saleListingStatuses = investmentListingStatusSchema.options;
